import React, { useState, useEffect } from 'react';
import supabase from '../../../supabase/supabase';
import SafeIcon from '../../../common/SafeIcon';
import { format } from 'date-fns';

const ComplianceTimingLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLogs = async () => {
      const { data, error } = await supabase
        .from('attendance_1741860000000')
        .select(`
          *,
          portal_users_1741860000000 (
            first_name,
            last_name,
            organisations_1741860000000 (name)
          )
        `)
        .order('check_in_time', { ascending: false });

      if (data) setLogs(data);
      setLoading(false);
    };

    fetchLogs();
  }, []);

  return (
    <div className="space-y-6">
      <header className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-serif font-bold text-navy-900">Timing & Attendance Logs</h2>
          <p className="text-slate-500 text-sm">Monitoring staff check-ins for compliance auditing.</p>
        </div>
        <div className="bg-gold-100 text-gold-700 px-4 py-2 rounded-lg text-xs font-bold uppercase tracking-widest border border-gold-200">
          Live Audit Mode
        </div>
      </header>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>
                <th className="p-4 font-bold text-navy-900">Staff Member</th>
                <th className="p-4 font-bold text-navy-900">Organisation</th>
                <th className="p-4 font-bold text-navy-900">Session</th>
                <th className="p-4 font-bold text-navy-900">Check-In Time</th>
                <th className="p-4 font-bold text-navy-900">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {logs.map((log) => (
                <tr key={log.id} className="hover:bg-slate-50 transition-colors">
                  <td className="p-4">
                    <span className="font-bold text-navy-900">
                      {log.portal_users_1741860000000?.first_name} {log.portal_users_1741860000000?.last_name}
                    </span>
                  </td>
                  <td className="p-4 text-slate-600">
                    {log.portal_users_1741860000000?.organisations_1741860000000?.name}
                  </td>
                  <td className="p-4 text-slate-500 italic">{log.session_name}</td>
                  <td className="p-4 font-mono text-xs">
                    {format(new Date(log.check_in_time), 'dd MMM yyyy, HH:mm:ss')}
                  </td>
                  <td className="p-4">
                    <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-green-100 text-green-700 text-[10px] font-bold uppercase">
                      <SafeIcon name="Check" className="w-3 h-3" /> Validated
                    </span>
                  </td>
                </tr>
              ))}
              {logs.length === 0 && !loading && (
                <tr>
                  <td colSpan="5" className="p-12 text-center text-slate-400 italic">
                    No attendance records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ComplianceTimingLogs;